export const DIVISION_LABELS = {
  ramp: "Ramp",
  ops: "Operations/Cargo",
  cargo: "Operations/Cargo",
  provisioning: "Provisioning",
};

export function divisionLabel(d) {
  return DIVISION_LABELS[d] || "Ramp";
}

export const AGENT_PORTAL_META = {
  ramp: { title: "Agent Portal", eyebrow: "Ramp · Roster" },
  ops: { title: "Ops Agent Portal", eyebrow: "Operations · Roster" },
  cargo: { title: "Cargo Agent Portal", eyebrow: "Cargo · Roster" },
  provisioning: { title: "Agent Portal", eyebrow: "Provisioning · Roster" },
};

export function agentPortalMeta(d) {
  return AGENT_PORTAL_META[d] || AGENT_PORTAL_META.ramp;
}
